module.exports = __webpack_public_path__ + "static/media/mail.71b69d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mail.png
// module id = 8
// module chunks = 0